import Link, { LinkProps } from '@mui/material/Link';
import { PropsWithChildren, forwardRef } from 'react';

type Props = PropsWithChildren<Omit<LinkProps, 'target' | 'rel'>>;

/**
 * 外部リンク用のコンポーネント
 */
export const ExternalLink = forwardRef<HTMLAnchorElement, Props>(
  ({ children, ...rest }, ref) => {
    // NOTE:
    // サポートサイトはリファラーをみて表示をするかしないかを判定しているため、
    // 外部リンクであってもnoreferrerは使用しない
    if (rest.href?.startsWith('https://clarislink-support.com')) {
      return (
        <Link ref={ref} target="_blank" rel="noopener" {...rest}>
          {children}
        </Link>
      );
    }

    return (
      <Link ref={ref} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </Link>
    );
  }
);
